export default "__VITE_ASSET__Chpj$95L__"